import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import { RemovePaymentMethodParams, removePaymentMethod } from '@utils/backend-api/stripe';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';

const useRemovePaymentMethod = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: RemovePaymentMethodParams) => removePaymentMethod(params),
    {
      onSuccess: () => {
        toast.success('Payment method removed successfully');
      },
      onError: (error: Partial<BillingErrorPayload> & { message?: string }) => {
        billingErrorToast(normalizeBillingError(error));
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useRemovePaymentMethod;
